module.exports = __webpack_public_path__ + "img/case-bg-4.51815224.png";